import { type ReactElement } from 'react';
import { useNavigate } from 'react-router-dom';
import { AlertCircle, LogIn } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { useAuth } from '@/hooks/use-auth';
import { ROUTES } from '@/lib/constants/routes';

export function ErrorPage(): ReactElement {
  const navigate = useNavigate();
  const { signOut, isAuthenticated } = useAuth();

  const handleGoToLogin = async (): Promise<void> => {
    await signOut();
    navigate(ROUTES.LOGIN, { replace: true });
  };

  return (
    <main className="flex min-h-screen items-center justify-center bg-muted/50 p-4">
      <section className="w-full max-w-md" aria-labelledby="error-heading">
        <Card className="w-full">
          <CardHeader className="text-center">
            <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-destructive/10">
              <AlertCircle className="h-6 w-6 text-destructive" aria-hidden />
            </div>
            <CardTitle id="error-heading" className="text-2xl">
              Something went wrong
            </CardTitle>
            <CardDescription>We encountered an unexpected error. Please try again later.</CardDescription>
          </CardHeader>
          <CardContent className="flex flex-col gap-2">
            {isAuthenticated ? (
              <Button type="button" onClick={() => navigate(ROUTES.BOOKING_REQUESTS)}>
                Go to booking requests
              </Button>
            ) : null}
            <Button type="button" variant="outline" onClick={() => void handleGoToLogin()}>
              <LogIn className="mr-2 h-4 w-4" aria-hidden />
              Go to Login
            </Button>
            <Button type="button" variant="outline" onClick={() => window.location.reload()}>
              Reload Page
            </Button>
          </CardContent>
        </Card>
      </section>
    </main>
  );
}
